import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/tryhala/Login.vue';
import Logout from '../views/tryhala/Logout.vue';
import PageNotFound from '../views/tryhala/PageNotFound.vue';
import pageLoader from '../components/pageLoader.vue';
import store from '../store';

Vue.use(VueRouter);

export const previewProductRedirectRouteNameMapper = {
    previewProduct: 'product',
    previewProducts: 'products',
    previewProductsByGroup: 'products',
    previewRdmGift: 'rdmGift',
    previewRdmGiftProduct: 'rdmGiftProduct'
};

const lazyLoadView = function(asyncView, beforeRouteLeave) {
    const AsyncHandler = () => ({
        component: asyncView,
        loading: pageLoader
    });
    return Promise.resolve({
        functional: true,
        beforeRouteLeave,
        render(h, { data, children }) {
            return h(AsyncHandler, data, children);
        }
    });
};

const showLoginRegisterModalOrNext = function(to, from, next) {
    if (
        [
            'createAccount',
            'login',
            'previewProducts',
            'previewProductsByGroup',
            'previewProduct',
            'termsOfUse',
            'privacyPolicy',
            'contactUs',
            'faq',
            'previewRdmGift',
            'previewRdmGiftProduct'
        ].includes(to.name)
    ) {
        next();
    } else {
        this.$store.commit('setShowLoginRegisterModal', true);
    }
};

const routes = [
    {
        path: '*',
        component: PageNotFound,
        meta: {
            showAd: false
        }
    },
    {
        path: '/pageNotFound',
        name: 'pageNotFound',
        component: PageNotFound,
        meta: { showAd: false }
    },
    {
        path: '/login/:cmpyToken?',
        name: 'login',
        component: Login,
        meta: {
            showAd: false,
            showTimeoutBannerWithGreet: true,
            title: '登入 | 試吓啦 TryHaLa'
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout,
        meta: { showAd: false }
    },
    {
        path: '/createAccount/:token',
        name: 'createAccount',
        meta: { showAd: false, showTimeoutBannerWithGreet: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "createAccount" */ '../views/tryhala/CreateAccount.vue'
                )
            )
    },
    {
        path: '/referral/:token/:refCustKey',
        name: 'referral',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "register" */ '../views/tryhala/Register.vue'
                )
            )
    },
    {
        path: '/register/:key',
        name: 'register',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "register" */ '../views/tryhala/Register.vue'
                )
            )
    },
    {
        path: '/confirmTermsOfUse',
        name: 'confirmTermsOfUse',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "confirmTermsOfUse" */ '../views/tryhala/ConfirmTermsOfUse.vue'
                ),
                (to, from, next) => {
                    if (
                        store.getters.requireConfirmTermsOfUse &&
                        to.name !== 'logout'
                    ) {
                        next(false);
                    } else {
                        next();
                    }
                }
            )
    },
    {
        path: '/friendMember',
        name: 'friendMember',
        meta: { showAd: false },
        beforeEnter: (to, from, next) => {
            next(store.getters.allowInviteFriendMember ? true : '/');
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "friendMember" */ '../views/tryhala/FriendMember.vue'
                )
            )
    },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "forgetPassword" */ '../views/tryhala/ForgetPassword.vue'
                )
            )
    },
    {
        path: '/resetPassword/:key',
        name: 'resetPassword',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "resetPassword" */ '../views/tryhala/ResetPassword.vue'
                )
            )
    },
    {
        path: '/confirmEmailAddress/:token',
        name: 'confirmEmailAddress',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "confirmEmailAddress" */ '../views/tryhala/ConfirmEmailAddress.vue'
                )
            )
    },
    {
        path: '/',
        name: 'home',
        meta: {
            showTimeoutBannerWithGreet: true,
            showFloatingCart: true,
            showFloatingAdvrt: true,
            showPopUpVideoAds: true
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "home" */ '../views/tryhala/Home.vue'
                )
            )
    },
    {
        path: '/beyondSalesPeriod',
        name: 'beyondSalesPeriod',
        meta: { showAd: false },
        beforeEnter: (to, from, next) => {
            if (!from.name) {
                next('/');
                return;
            }
            next();
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "BeyondSalesPeriod" */ '../views/tryhala/BeyondSalesPeriod.vue'
                )
            )
    },
    {
        path: '/product/:id?',
        name: 'product',
        meta: {
            showFloatingCart: true,
            showFloatingAdvrt: true
        },
        beforeEnter: (to, from, next) => {
            const pid = to.params.id;
            if (!pid || store.getters.productList.every(p => p.id != pid)) {
                next('/');
                return;
            }
            next();
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "product" */ '../views/tryhala/ProductDetail.vue'
                )
            )
    },
    {
        path: '/salesLink/:token',
        name: 'salesLink',
        meta: {
            showAd: false
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "salesLink" */ '../views/tryhala/SalesLink.vue'
                )
            )
    },
    {
        path: '/eventTicketVerify/:token',
        name: 'eventTicketVerify',
        meta: {
            showAd: false
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "eventTicket" */ '../views/tryhala/EventTicketVerify.vue'
                )
            )
    },
    {
        path: '/eventTicketVerifyDemo/:prodSkuNum',
        name: 'eventTicketVerifyDemo',
        meta: {
            showAd: false
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "eventTicketDemo" */ '../views/tryhala/EventTicketVerifyDemo.vue'
                )
            )
    },
    {
        path: '/cart',
        name: 'cart',
        meta: { showTimeoutBannerWithGreet: true },
        beforeEnter: (to, from, next) => {
            store.commit('setCpn', undefined);
            store.commit('setCreditPoint', 0);
            store.commit('setUseCoupon', false);
            store.commit('setUseCreditPoint', false);
            next(store.getters.isShoppingListOpen ? true : '/');
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "cart" */ '../views/tryhala/Cart.vue'
                )
            )
    },
    {
        path: '/fps',
        name: 'fps',
        meta: {
            showAd: false
        },
        beforeEnter: (to, from, next) => {
            if (
                !from ||
                !['cart', 'salesLink'].includes(from.name) ||
                !store.state?.fpsQrCode
            ) {
                next('/');
                return;
            }
            next();
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "fps" */ '../views/tryhala/FpsPayment.vue'
                )
            )
    },
    {
        path: '/success',
        name: 'success',
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "success" */ '../views/tryhala/PaymentSuccess.vue'
                )
            )
    },
    {
        path: '/fail',
        name: 'fail',
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "fail" */ '../views/tryhala/PaymentFail.vue'
                )
            )
    },
    {
        path: '/account',
        name: 'account',
        redirect: '/account/accountInfo',
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "account" */ '../views/tryhala/Account.vue'
                )
            ),
        children: [
            {
                path: 'accountInfo',
                name: 'accountInfo',
                meta: {
                    showAd: false,
                    showTimeoutBannerWithGreet: true
                    // showConfirmPhoneNumber: false
                },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "order" */ '../views/tryhala/AccountInfo.vue'
                        )
                    )
            },
            {
                path: 'orderHistory',
                name: 'orderHistory',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "order" */ '../views/tryhala/OrderHistory.vue'
                        )
                    )
            },
            {
                path: 'orderHistory/:orderNo',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                name: 'order',
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "order" */ '../views/tryhala/OrderView.vue'
                        )
                    )
            },
            {
                path: 'creditPointHistory',
                name: 'creditPointHistory',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "order" */ '../views/tryhala/CreditPointHistory.vue'
                        )
                    )
            },
            {
                path: 'purchasedProduct',
                name: 'purchasedProduct',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "order" */ '../views/tryhala/PurchasedProduct.vue'
                        )
                    )
            },
            {
                path: 'purchasedProduct/:prodId',
                name: 'purchasedProductInfo',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                props: {
                    breadcrumbPrependLinks: [
                        {
                            msg: 'purchased.order.history',
                            route: { name: 'purchasedProduct' }
                        }
                    ]
                },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "product" */ '../views/tryhala/ProductInformation.vue'
                        )
                    )
            },
            {
                path: 'feedback',
                name: 'feedback',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "feedback" */ '../views/tryhala/Feedback.vue'
                        )
                    )
            },
            {
                path: 'eventTicketHistory',
                name: 'eventTicketHistory',
                meta: { showAd: false, showTimeoutBannerWithGreet: true },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "eventTicket" */ '../views/tryhala/EventTicketHistory.vue'
                        )
                    )
            }
        ]
    },
    {
        path: '/products/:saleCatgSlctCode/:prodCatgSlctKey?',
        name: 'products',
        meta: {
            showTimeoutBannerWithGreet: true,
            showFloatingCart: true,
            showFloatingAdvrt: true,
            showPopUpVideoAds: true
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "products" */ '../views/tryhala/ProductGroup.vue'
                )
            )
    },
    {
        path: '/productInfo/:prodId',
        name: 'productInfo',
        meta: { showAd: false },
        beforeEnter: (to, from, next) => {
            const prodId = to.params.prodId;
            const matchProd = store.getters.productList.find(
                p => p.prodId === prodId
            );
            if (matchProd) {
                next(`/product/${matchProd.id}`);
                return;
            }

            next();
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "product" */ '../views/tryhala/ProductInformation.vue'
                )
            )
    },
    {
        path: '/productDetailPreview/:prodId',
        name: 'productDetailPreview',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "product" */ '../views/tryhala/ProductDetailPreview.vue'
                )
            )
    },
    {
        path: '/previewProducts/:cmpyToken',
        name: 'previewProducts',
        meta: { showTimeoutBannerWithGreet: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewProduct" */ '../views/tryhala/PreviewProducts.vue'
                ),
                showLoginRegisterModalOrNext
            )
    },
    {
        path: '/previewProducts/:cmpyToken/:saleCatgSlctCode/:prodCatgSlctKey?',
        name: 'previewProductsByGroup',
        meta: { showTimeoutBannerWithGreet: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewProduct" */ '../views/tryhala/PreviewProductGroup.vue'
                ),
                showLoginRegisterModalOrNext
            )
    },
    {
        path: '/previewProduct/:cmpyToken/id/:id?',
        name: 'previewProduct',
        meta: { showTimeoutBannerWithGreet: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewProduct" */ '../views/tryhala/PreviewProductDetail.vue'
                ),
                showLoginRegisterModalOrNext
            )
    },
    {
        path: '/previewShoppingList/:shopListKey',
        name: 'previewShoppingList',
        meta: { showFloatingAdvrt: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewShoppingList" */ '../views/tryhala/PreviewShoppingList.vue'
                )
            )
    },
    {
        path:
            '/previewShoppingList/:shopListKey/:saleCatgSlctCode/:prodCatgSlctKey?',
        name: 'previewShoppingListByGroup',
        meta: { showFloatingAdvrt: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewShoppingList" */ '../views/tryhala/PreviewShoppingListByGroup.vue'
                )
            )
    },
    {
        path: '/previewShoppingListProduct/:shopListKey/id/:id?',
        name: 'previewShoppingListProduct',
        meta: { showFloatingAdvrt: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewShoppingList" */ '../views/tryhala/PreviewShoppingListProduct.vue'
                )
            )
    },
    {
        path: '/termsOfUse',
        name: 'termsOfUse',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "webSiteInfo" */ '../views/tryhala/TermsOfUse.vue'
                )
            )
    },
    {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "webSiteInfo" */ '../views/tryhala/PrivacyPolicy.vue'
                )
            )
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        meta: { showAd: false, title: '關於我們 | 試吓啦 TryHaLa' },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "webSiteInfo" */ '../views/tryhala/ContactUs.vue'
                )
            )
    },
    {
        path: '/faq',
        name: 'faq',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "webSiteInfo" */ '../views/tryhala/FAQ.vue'
                )
            )
    },
    {
        path: '/tcoin',
        name: 'tcoin',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "webSiteInfo" */ '../views/tryhala/Tcoin.vue'
                )
            )
    },
    {
        path: '/event/:eventId',
        name: 'promotionEvent',
        redirect: { name: 'promotionEventDetail' },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "luckyDraw" */ '../views/tryhala/PromotionEvent.vue'
                )
            ),
        children: [
            {
                path: 'detail',
                name: 'promotionEventDetail',
                meta: { showAd: false },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "luckyDraw" */ '../views/tryhala/PromotionEventDetail.vue'
                        )
                    )
            },
            {
                path: 'history',
                name: 'promotionEventHistory',
                meta: { showAd: false },
                component: () =>
                    lazyLoadView(
                        import(
                            /* webpackChunkName: "luckyDraw" */ '../views/tryhala/PromotionEventHistory.vue'
                        )
                    )
            }
        ]
    },
    {
        path: '/feedback/:prodFdbkEmailTknNum',
        name: 'feedbackByToken',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "feedback" */ '../views/tryhala/Feedback.vue'
                )
            )
    },
    {
        path: '/rdmGift/:prodCatgSlctKey?',
        name: 'rdmGift',
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "rdmGift" */ '../views/tryhala/RdmGift.vue'
                )
            )
    },
    {
        path: '/rdmGiftProduct/:id?',
        name: 'rdmGiftProduct',
        beforeEnter: (to, from, next) => {
            const pid = to.params.id;
            if (!pid || store.getters.rdmGiftProdList.every(p => p.id != pid)) {
                next('/');
                return;
            }
            next();
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "rdmGift" */ '../views/tryhala/RdmGiftProduct.vue'
                )
            )
    },
    {
        path: '/previewRdmGift/:cmpyToken/:prodCatgSlctKey?',
        name: 'previewRdmGift',
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewRdmGift" */ '../views/tryhala/PreviewRdmGift.vue'
                ),
                showLoginRegisterModalOrNext
            )
    },
    {
        path: '/previewRdmGiftProduct/:cmpyToken/id/:id?',
        name: 'previewRdmGiftProduct',
        meta: { showTimeoutBannerWithGreet: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "previewRdmGift" */ '../views/tryhala/PreviewRdmGiftProduct.vue'
                ),
                showLoginRegisterModalOrNext
            )
    },
    {
        path: '/bofLogin',
        name: 'bofLogin',
        meta: { showAd: false, title: '登入 | 試吓啦 TryHaLa' },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "bofLogin" */ '../views/tryhala/BofLogin.vue'
                )
            )
    },
    {
        path: '/companyQuickJoin',
        name: 'companyQuickJoin',
        meta: { showAd: false },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "companyQuickJoin" */ '../views/tryhala/CompanyQuickJoin.vue'
                )
            )
    }
];

if (process.env.NODE_ENV !== 'production') {
    routes.push({
        path: '/demoProductCarousel',
        name: 'demoProductCarousel',
        meta: { showAd: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "demo" */ '../views/tryhala/demoProductCarousel.vue'
                )
            )
    });
    routes.push({
        path: '/demoRecaptchaForm',
        name: 'demoRecaptchaForm',
        meta: { showAd: true },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "demo" */ '../views/tryhala/demoRecaptchaForm.vue'
                )
            )
    });
    routes.push({
        path: '/demoHsbcFps',
        name: 'demoHsbcFps',
        meta: {
            showAd: false
        },
        beforeEnter: (from, to, next) => {
            store.commit('setFpsData', {
                fpsQrCode:
                    '00020101021226460012hk.com.hkicl021020180711010512180731112742520400005303344540510.505802HK5902NA6002HK622905250002900F064577105000000016304EE2F',
                fpsPymtAmt: 175,
                fpsCurrentOrdNo: undefined,
                fpsCurrentOrdKey: undefined
            });
            next();
        },
        component: () =>
            lazyLoadView(
                import(
                    /* webpackChunkName: "demo" */ '../views/tryhala/FpsPayment.vue'
                )
            )
    });
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

const permitPages = [
    {
        match: () => true, //public page
        names: [
            'pageNotFound',
            'termsOfUse',
            'privacyPolicy',
            'contactUs',
            'faq',
            'productInfo',
            'productDetailPreview',
            'confirmEmailAddress',
            'previewShoppingList',
            'previewShoppingListByGroup',
            'previewShoppingListProduct',
            'salesLink',
            'eventTicketVerify',
            'eventTicketVerifyDemo',
            ...(process.env.NODE_ENV !== 'production'
                ? ['demoRecaptchaForm']
                : [])
        ]
    },
    {
        match: () => !store.state.user,
        redirect: () => '/',
        names: [
            'login',
            'createAccount',
            'register',
            'forgetPassword',
            'resetPassword',
            'referral'
        ]
    },
    {
        match: () => !store.state.bofUser,
        redirect: () => ({ name: 'companyQuickJoin' }),
        names: ['bofLogin']
    },
    {
        match: () => !store.state.user,
        redirect: to => {
            const name = previewProductRedirectRouteNameMapper[to.name];
            return name
                ? {
                      name: name,
                      params: to.params
                  }
                : '/';
        },
        names: ['previewProduct', 'previewProducts', 'previewProductsByGroup']
    },
    {
        match: () => !store.state.user,
        redirect: to => {
            const name = previewProductRedirectRouteNameMapper[to.name];
            return name
                ? {
                      name: name,
                      params: to.params
                  }
                : '/';
        },
        names: ['previewRdmGift', 'previewRdmGiftProduct']
    },
    {
        match: () => !store.state.user,
        redirect: () => ({
            name: 'feedback'
        }),
        names: ['feedbackByToken']
    },
    {
        match: () => store.state.bofUser,
        redirect: () => '/bofLogin',
        names: ['companyQuickJoin']
    },
    {
        match: () => store.state.user || store.state.bofUser,
        redirect: () => '/login',
        names: ['logout']
    },
    {
        match: () => !store.getters.isFriendCustomer,
        redirect: () => '/',
        names: ['creditPointHistory', 'feedback']
    },
    {
        match: () => store.state.user,
        redirect: to => {
            let params = {};
            if (
                [/^\/account\/orderHistory\/.+$/].some(reg =>
                    reg.test(to.path)
                ) ||
                [/^\/products\/.+$/].some(reg => reg.test(to.path)) ||
                [/^\/rdmGift.*$/].some(reg => reg.test(to.path))
            ) {
                params = { lastPath: to.path };
            }
            return { name: 'login', params };
        },
        names: '*'
    }
];

router.beforeEach((to, from, next) => {
    permitPages.some(p => {
        //if (p.paths === '*' || p.paths.some(_p => to.path.indexOf(_p) === 0)) {
        if (p.names === '*' || p.names.some(_n => to.name === _n)) {
            document.title =
                to.meta && to.meta.title ? to.meta.title : '試吓啦 TryHaLa';

            if (p.match()) {
                next();
            } else {
                next(p.redirect(to, from));
            }
            return true;
        }
    });
});

export default router;
